import { Observable } from 'rxjs';
import { AuthLoginInput } from '../models/auth-login-input.data';
import { LoginExternalResponse } from '@/data/auth/services/ezy/responses/login-external.response';
import { RestoreResponse } from '@/data/auth/services/ezy/responses/restore.response';

export abstract class AuthApi {
    abstract login(input: AuthLoginInput): Observable<LoginExternalResponse>;
    abstract restore(authToken: string): Observable<RestoreResponse>;
}
